import { render, staticRenderFns } from "./combo-setting.vue?vue&type=template&id=7c2196fb&scoped=true"
import script from "./combo-setting.vue?vue&type=script&lang=js"
export * from "./combo-setting.vue?vue&type=script&lang=js"
import style0 from "./combo-setting.vue?vue&type=style&index=0&id=7c2196fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2196fb",
  null
  
)

export default component.exports